import { Loader2 } from "lucide-react";

export const LoadingMetricCard = ({ label }: { label: string }) => {
  return (
    <div className="bg-brand-card border border-brand-border rounded-[14px] p-4 shadow-sm flex flex-col gap-2 w-1/3">
      <div className="flex gap-2 items-center">
        <div className="relative shrink-0 w-8 h-8">
          <div className="absolute inset-0 bg-brand-primary opacity-15 rounded-[6px]" />
          <div className="absolute left-2 top-2 w-4 h-4 text-brand-primary">
            <Loader2 className="w-4 h-4 animate-spin" />
          </div>
        </div>
      </div>
      <p className="text-base font-semibold leading-6 text-brand-foreground">
        {label}
      </p>
    </div>
  );
};
